import { ApiClientError, CreateFolder, Folder } from '@raydiant/api-client-js';
import { useQueryClient } from 'react-query';
import raydiant from '../clients/raydiant';
import { keys } from '../queryClient';
import useProtectedMutation from './useProtectedMutation';
import { LibraryQueryParams } from '../pages/LibraryPage/utils';

export default function useCreateFolder(query: LibraryQueryParams) {
  const queryClient = useQueryClient();
  const parentFolderId = query.folder_id || null;

  const invalidateFolderQuery = (folderId: string) => {
    queryClient.invalidateQueries(
      keys.library({ ...query, folder_id: folderId }),
    );
  };

  const mutation = useProtectedMutation<Folder, ApiClientError, CreateFolder>(
    async (data) => {
      const folder = await raydiant.createFolder(data);
      if (parentFolderId) {
        await raydiant.moveFolderToFolder(folder.id, parentFolderId);
      }
      return folder;
    },
    {
      onSuccess: (createdFolder) => {
        invalidateFolderQuery(createdFolder.id);
      },
    },
  );

  return mutation;
}
